import statusHeaderActionTypes from '../../../constants/actions/dossier/common/statusHeader'

export function toggleTimeline () {
  return {
    type: statusHeaderActionTypes.TOGGLE_TIMELINE
  }
}

export function setStatusHeaderHeight (height) {
  return {
    type: statusHeaderActionTypes.SET_STATUS_HEADER_HEIGHT,
    height
  }
}

export function resetStatusHeader () {
  return {
    type: statusHeaderActionTypes.RESET_STATUS_HEADER
  }
}

export default {
  toggleTimeline,
  setStatusHeaderHeight,
  resetStatusHeader
}
